import {ChevronLeft, ChevronRight} from '@mui/icons-material';
import {Box, Button, IconButton, Typography} from '@mui/material';

export interface StudyPageSectionNavigationProps {
  currentIndex: number;
  totalSections: number;
  onPrevious: () => void;
  onNext: () => void;
  isMobile?: boolean;
}

export default function StudyPageSectionNavigation({
  currentIndex,
  totalSections,
  onPrevious,
  onNext,
  isMobile = false,
}: StudyPageSectionNavigationProps) {
  if (isMobile) {
    return (
      <Box
        sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}
        data-testid="study-page-section-navigation"
      >
        <IconButton
          onClick={onPrevious}
          disabled={currentIndex === 0}
          size="small"
          data-testid="study-page-previous-button"
        >
          <ChevronLeft />
        </IconButton>
        <Typography variant="body2" color="text.secondary" data-testid="study-page-section-progress">
          {currentIndex + 1} / {totalSections}
        </Typography>
        <IconButton
          onClick={onNext}
          disabled={currentIndex === totalSections - 1}
          size="small"
          data-testid="study-page-next-button"
        >
          <ChevronRight />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 2}} data-testid="study-page-section-navigation">
      <Button
        startIcon={<ChevronLeft />}
        onClick={onPrevious}
        disabled={currentIndex === 0}
        variant="outlined"
        data-testid="study-page-previous-button"
      >
        Previous
      </Button>
      <Typography
        variant="body2"
        sx={{alignSelf: 'center', color: 'text.secondary'}}
        data-testid="study-page-section-progress"
      >
        {currentIndex + 1} / {totalSections}
      </Typography>
      <Button
        endIcon={<ChevronRight />}
        onClick={onNext}
        disabled={currentIndex === totalSections - 1}
        variant="outlined"
        data-testid="study-page-next-button"
      >
        Next
      </Button>
    </Box>
  );
}
